import { RED_XL_GROUP, SALESCHANNEL_YOUNG } from '@vfde-fe/sails-constants';

/**
 * getIsRestlaufzeitEligible
 * Restlaufzeit is eligible when:
 * isGigakombi true, salesChannel is not young and activeSubscriptionId is not RED_XL_GROUP
 */
export const getIsRestlaufzeitEligible = (isGigakombi: boolean, salesChannel: string, activeSubscriptionId: number): boolean => {

    return isGigakombi && salesChannel !== SALESCHANNEL_YOUNG && activeSubscriptionId !== RED_XL_GROUP;
};
